import { AccountsNavigation } from '../components/accounts-navigation/AccountsNavigation'
import { GeneralStatsBar } from '../components/general-stats-bar/GeneralStatsBar'
import { PageHeader } from '../components/PageHeader'
import { SavingsAccount } from '../components/savings-account/SavingsAccount'
import { UseSavingsGeneralStatsResult } from '../data/useGeneralStats'
import { AccountDefinition, AccountsNavigationProps, StusdsWarningData } from '../types'
import { BaseMiniAppOptions } from '@/base-miniapp/types'
import { Token } from '@/domain/types/Token'
import { UseSavingsChartsResult } from '@/features/savings/logic/useSavingsCharts'
import { PageLayout } from '@/ui/layouts/PageLayout'

export interface SavingsViewProps {
  headerChainId: number | undefined
  navigationProps: AccountsNavigationProps
  selectedAccount: AccountDefinition
  generalStats: UseSavingsGeneralStatsResult
  openDepositDialog: (tokenToDeposit: Token) => void
  openConvertStablesDialog: () => void
  openSendDialog: () => void
  openWithdrawDialog: () => void
  openSandboxModal: () => void
  openConnectModal: () => void
  guestMode: boolean
  isInSandbox: boolean
  charts: UseSavingsChartsResult
  stusdsWarningData: StusdsWarningData | undefined
  baseMiniAppOptions: BaseMiniAppOptions | undefined
}

export function SavingsView({
  headerChainId,
  navigationProps,
  selectedAccount,
  openDepositDialog,
  openConvertStablesDialog,
  openSendDialog,
  openWithdrawDialog,
  openSandboxModal,
  openConnectModal,
  guestMode,
  generalStats,
  isInSandbox,
  charts,
  stusdsWarningData,
  baseMiniAppOptions,
}: SavingsViewProps) {
  return (
    <PageLayout>
      <div className="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between">
        <PageHeader chainId={headerChainId} />
        <GeneralStatsBar
          savingsToken={selectedAccount.savingsToken}
          underlyingToken={selectedAccount.underlyingToken}
          generalStatsResult={generalStats}
          {...charts.generalStatsChartsProps}
        />
      </div>
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-[202px_1fr]">
        <AccountsNavigation {...navigationProps} />
        <SavingsAccount
          {...selectedAccount}
          openDepositDialog={openDepositDialog}
          openConvertStablesDialog={openConvertStablesDialog}
          openSendDialog={openSendDialog}
          openWithdrawDialog={openWithdrawDialog}
          openSandboxModal={openSandboxModal}
          openConnectModal={openConnectModal}
          guestMode={guestMode}
          isInSandbox={isInSandbox}
          charts={charts}
          stusdsWarningData={stusdsWarningData}
          baseMiniAppOptions={baseMiniAppOptions}
        />
      </div>
    </PageLayout>
  )
}
